import { render, staticRenderFns } from "./FoodCards.vue?vue&type=template&id=cf9ad9b6&scoped=true"
import script from "./FoodCards.vue?vue&type=script&lang=js"
export * from "./FoodCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9ad9b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Filati\\filatiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf9ad9b6')) {
      api.createRecord('cf9ad9b6', component.options)
    } else {
      api.reload('cf9ad9b6', component.options)
    }
    module.hot.accept("./FoodCards.vue?vue&type=template&id=cf9ad9b6&scoped=true", function () {
      api.rerender('cf9ad9b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FoodCards.vue"
export default component.exports